export const ADMIN = 'Admin';
export const OWNER = 'Owner';
export const CEO = 'CEO';
export const PARTNER_EMPLOYESS = 'PartnerEmployees';
export const SUPERMANAGER = 'Supermanager';
export const DEPARTMENT_HEAD = 'DepartmentHead';
export const PARTNER = 'Partner';
export const MANAGER = 'Manager';
export const CLIENT = 'Client';
